'use strict';

var $ = require('jquery');
var disablingLayer = require('vhi-ui-framework/src/main/js/panels/disablingLayer');
var intlPageSetup = require('../utils/intlPageSetup');
var addonsService = require('../services/addonsService');
var addonsBoxJade = require('vhi-ui-framework/src/main/jade/intl/addonsBox.jade');
var urls = require('shared/scripts/modules/utils/urls');

var transactionStageService = require('../services/transactionStageService');
var breadCrumb = require('../utils/breadCrumb');
var thisPageAnalytics = require('./join-plan-addons-analytics');

var transactionId;

function init() {

    transactionId = urls.getUrlParameter("transaction-id");
    var nextPageUrl = '/intgroups/join-preferences?transaction-id=' + transactionId;
    var transactionStage = transactionStageService.getTransactionStage();

    return $.when(intlPageSetup.init(), addonsService.getAvailableAddonsList(transactionId), addonsService.getAddonsList(transactionId))
        .then(function (setup, availableAddons, selectedAddons) {
            $('#addonsBox').html(addonsBoxJade({ addons: availableAddons }));

            $('.addon-container').localize();
            $('.journey-content').localize();
            $('.addon-footer').localize();

            checkAddonCheckboxes(selectedAddons);
            initListeners();

            disablingLayer.hideDisablingLayer();
            initBreadCrumb();

        });
    
    function initListeners() {
        var btnNext = $('#next');

        if (pageHasCheckedCheckboxes()) {
            btnNext.prop('disabled', false);
        } else {
            btnNext.prop('disabled', true);
        }

        btnNext.on('click', onNextClick);
        $('#thanks').on('click', onThanksClick);

        $('.checkbox').change(function () {
            if(this.checked) {
                btnNext.prop('disabled', false);
            }
            else if(!pageHasCheckedCheckboxes()) {
                btnNext.prop('disabled', true);
            }
        });

        thisPageAnalytics.addAnalyticsHandlers();
    }

    function pageHasCheckedCheckboxes() {
        var result = false;
        $(".checkbox").each(function () {
            if($(this).prop('checked') === true) {
                result = true;

            }
        });
        return result;
    }

    function checkAddonCheckboxes(addons) {
        $(".checkbox").each(function () {
            for (var i = 0; i < addons.length; i++) {
                if ($(this).val() === addons[i].code) {
                    $(this).prop('checked', true);
                }
            }
        });
    }


    function initBreadCrumb() {
        breadCrumb.init({
            sessionTransactionStage: transactionStage
        });
    }
    
    function onNextClick(event) {
        event.preventDefault();

        var addons = [];
        $(".checkbox:checked").each(function () {
            addons.push({ code: $(this).val() });
        });

        postAddons(addons);
    }
    
    function onThanksClick(event) {
        event.preventDefault();

        postAddons([]);
    }

    function postAddons(addons) {
        addonsService.postAddonsList(addons, transactionId)
            .done(function () {
                transactionStageService.setTransactionStage("PREFERENCES");
                urls.navigateToUrl(nextPageUrl);
            })
            .fail("unable to post selected addons list");
    }
}

module.exports.init = init;



//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/pages/join-plan-addons.js
// module id = NvBc
// module chunks = 6